import { ColorConverter, ObjectCreator } from "../../../../../../../../web-graphics";
import { SettingsParser } from "../../../settings-parser";
import { getSizeSettings } from "../../../../../utils/get-size-settings";
import { SignalLabelSettings } from "../../../../settings/view-objects/plot/content/signal-label-settings";

export class SignalLabelPlotContentParser extends SettingsParser {
  constructor() {
    super();
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      if (defaultSettings !== undefined) {
        return ObjectCreator.deepCopy(defaultSettings);
      }
      return undefined;
    }
    let parsedSettings = ObjectCreator.merge(settings, defaultSettings);
    if (parsedSettings.color !== undefined) {
      let parsedColor = ColorConverter.convertToWebglRgba(parsedSettings.color);
      parsedSettings.color = parsedColor.value;
    }
    parsedSettings.y = getSizeSettings(parsedSettings.y, 0, 0);
    if (parsedSettings.linkedPosition === undefined) {
      parsedSettings.linkedPosition = true;
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = SignalLabelPlotContentParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    return new SignalLabelSettings(parsedSettings);
  }
}
